<template>
  <div class="modal fade slide-right"
       id="confirmModal"
       role="dialog"
       aria-hidden="true"
       data-backdrop="static">
    <div class="modal-dialog modal-sm modal-payment"
         style="width:500px;">
      <div class="modal-content-wrapper">
        <div class="modal-content"
             style="width:500px;height:100%;">
          <div class="modal-header clearfix text-left">
            <button type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-hidden="true">
              <i class="pg-close fs-14"
                 @click="$emit('close-modal')"></i>
            </button>
            <div class="col-md-12 modal-left">
              <h2 class="modal-title">Suppression d'une interaction</h2>
            </div>
          </div>
          <div class="modal-body">
            <div class="col-md-12 modal-right">
              <notifications v-if="is_any_errors"
                             :errors="errors"
                             @close-error="reset_error($event)"
                             >
              </notifications>
              <h4>Type : {{interaction.decoded_type}} <span v-if="interaction.type == 'other'">({{interaction.other_type}})</span></h4>
              <p>
                Etes vous sur de vouloir supprimer cette interaction ?
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-complete btn-cons" @click="delete_interaction"
                    >Confirmer</button>
            <button type="button"
                    class="btn btn-default btn-cons no-margin inline"
                    data-dismiss="modal"
                    @click="$emit('close-modal')">Annuler
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex"
import Notifications from "components/CRM/Notifications"

export default {
  name:"InteractionDeletionModal",
  props:["lead_id", "lead_interaction_id", "interaction"],
  components:{
    Notifications
  },
  mounted () {
    $(this.$el).modal()
  },
  beforeDestroy () {
    $(this.$el).modal('hide')
    $('body').removeClass('modal-open')
    $('.modal-backdrop').remove()
  },
  computed:{
    ...mapGetters("crm", ["is_any_errors","errors"]),
  },
  methods:{
    ...mapActions("crm", ["destroy_interaction", "set_fetching_state", "fetch_interactions","reset_error","reset_errors","fetch_a_lead"]),
    delete_interaction() {
      this.reset_errors()
      this.destroy_interaction({lead_id:this.lead_id, lead_interaction_id:this.lead_interaction_id})
          .then(() => {
            this.set_fetching_state(true)
            this.fetch_a_lead(this.lead_id)
                .then(() => this.set_fetching_state(false))

          })
          .then(() => {
            if (!this.is_any_errors)
              this.$emit('close-modal')
          })
    }
  }
}

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// client/components/CRM/Interactions/InteractionModal.vue